import AuthService from '../services/auth.service';
import axios from "axios";

const user = JSON.parse(localStorage.getItem('user'));
const invoiceData = {
    name: '',
    address: '',
    utr: '',
    account_name: '',
    account_no: '',
    short_code: '',
    invoiceNo: ''
}
const initialState = user ? { status: { loggedIn: true }, user, invoiceData, userEditingData: false } : { status: { loggedIn: false }, user: null, invoiceData, userEditingData: false };

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        setUserTeamChangeStatus({ commit }, data) {
            commit('changeUserTeamStatus', data);
        },
        setUserStatus({ commit }, data) {
            commit('changeUserStatus', data);
        },
        setUserCompletionSteps({ commit }, data) {
            commit('changeUserCompletionSteps', data);
        },
        setUserTemplateOptions({ commit }, data) {
            commit('changeUserTemplateOptions', data);
        },
        userEditingData({ commit }, data) {
            commit('setUserEditingData');
        },
        setUserInvoiceNumber({ commit }, data) {
            commit('changeUserInvoiceNumber', data);
        },
        setInvoiceData({ commit }) {
            commit('setInvoiceData');
        },
        setProfileImage({ commit }, data) {
            commit('changeProfileImage', data);
        },
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
            axios.defaults.headers.common['x-access-token'] = user.accessToken

            if (user.status) {
                state.user.status = JSON.parse(user.status)
            }

            if (user.templateOptions) {
                state.user.templateOptions = user.templateOptions
            }
        },
        setInvoiceData(state) {
            const user = state.user
            if (user.templateOptions && user.templateOptions.financial) {
                const address = `${user.templateOptions.street_address}, ${user.templateOptions.house_number}, ${user.templateOptions.city}, ${user.templateOptions.country}, ${user.templateOptions.zip_code}`
                state.invoiceData = {
                    name: user.templateOptions.last_name + ' ' + user.templateOptions.first_name,
                    address,
                    utr: user.templateOptions.financial.utr_no,
                    account_name: user.templateOptions.financial.account_name,
                    account_no: user.templateOptions.financial.account_no,
                    short_code: user.templateOptions.financial.short_code,
                    invoiceNo: user.invoiceNo ? parseInt(user.invoiceNo) + 1 : null
                }
            }
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            location.reload()
            state.user = null;
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },
        setUserEditingData(state) {
            state.userEditingData = true;
        },
        changeProfileImage(state, profileImage) {
            state.user.profileImage = profileImage;
        },
        changeUserTeamStatus(state, requestedTeamChange) {
            state.user.requestedTeamChange = requestedTeamChange
        },
        changeUserStatus(state, status) {
            state.user.status = status ? JSON.parse(status) : status
        },
        changeUserCompletionSteps(state, data) {
            if (state.user.templateOptions[data.type] && state.user.templateOptions[data.type] < data.step) {
                state.user.templateOptions[data.type] = data.step
            }
        },
        changeUserTemplateOptions(state, templateOptions) {
            state.user.templateOptions = templateOptions
            localStorage.setItem('user', JSON.stringify(state.user));
        },
        changeUserInvoiceNumber(state, invoiceNo) {
            state.invoiceData.invoiceNo = invoiceNo
        },
    }
};